import { render, staticRenderFns } from "./TrainingSectionSkeleton.vue?vue&type=template&id=47017a7c&scoped=true"
import script from "./TrainingSectionSkeleton.vue?vue&type=script&lang=js"
export * from "./TrainingSectionSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TrainingSectionSkeleton.vue?vue&type=style&index=0&id=47017a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47017a7c",
  null
  
)

export default component.exports